/* unplugin-vue-components disabled */import { render } from "./UserSPEList.vue?vue&type=template&id=28d635d4&scoped=true&ts=true"
import script from "./UserSPEList.vue?vue&type=script&lang=ts"
export * from "./UserSPEList.vue?vue&type=script&lang=ts"

import "./UserSPEList.vue?vue&type=style&index=0&id=28d635d4&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-28d635d4"]])

export default __exports__